var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-container" }, [
    _c(
      "div",
      { staticClass: "hx-breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { "separator-class": "el-icon-arrow-right" } },
          [
            _c("el-breadcrumb-item", [_vm._v("首页")]),
            _c("el-breadcrumb-item", [_vm._v("供应系统")]),
            _c("el-breadcrumb-item", [_vm._v("供应点管理")]),
            _c("el-breadcrumb-item", [_vm._v("交易管理")]),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { name: "supplyCentreTradeInquire" } } },
              [_vm._v("交易查询")]
            ),
            _c("el-breadcrumb-item", [_vm._v("交易订单详情")]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "hx-form-container box-shadow" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.orderTableLoading,
                expression: "orderTableLoading",
              },
            ],
            attrs: {
              "show-summary": "",
              "summary-method": _vm.getSummaries,
              data: _vm.orderTableData,
            },
          },
          [
            _c("el-table-column", {
              attrs: { align: "center", prop: "title", label: "商品名称" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("div", { staticClass: "commodity-name-style" }, [
                        _c("div", { staticClass: "commodity-wrap-img-style" }, [
                          _c("img", {
                            staticClass: "commodity-img-style",
                            attrs: { src: scope.row.coverImage, alt: "" },
                          }),
                          _c("span", [_vm._v(_vm._s(scope.row.title))]),
                        ]),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                prop: "productPrice",
                label: "商品价格",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatToFixed2")(
                              scope.row.productPrice,
                              "元"
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                prop: "productSpec",
                label: "商品规格",
              },
            }),
            _c("el-table-column", {
              attrs: { align: "center", prop: "quantity", label: "商品数量" },
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                prop: "paymentAmount",
                label: "商品定金",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatToFixed2")(
                              scope.row.paymentAmount,
                              "元"
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                prop: "levelDiscountAmount",
                label: "级别折扣金额",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatToFixed2")(
                              scope.row.levelDiscountAmount,
                              "元"
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                prop: "orderAmount",
                label: "商品总价",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatToFixed2")(
                              scope.row.orderAmount,
                              "元"
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "hx-form-container box-shadow" }, [
      _c("p", { staticClass: "form-title" }, [_vm._v("订单信息")]),
      _c(
        "div",
        { staticClass: "form-details" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.orderInfoForm } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c("el-form-item", { attrs: { label: "订单编号：" } }, [
                        _vm._v(" " + _vm._s(_vm.orderInfoForm.orderNo) + " "),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c("el-form-item", { attrs: { label: "下单日期：" } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("formatDate")(
                                _vm.orderInfoForm.paymentDate,
                                true
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c("el-form-item", { attrs: { label: "订单状态：" } }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.orderInfoForm.orderStatusDisplay) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c("el-form-item", { attrs: { label: "支付状态：" } }, [
                        _vm._v(
                          " " + _vm._s(_vm.orderInfoForm.paymentStatus) + " "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c("el-form-item", { attrs: { label: "商品总金额：" } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("formatToFixed2")(
                                _vm.orderInfoForm.orderAmount
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c("el-form-item", { attrs: { label: "订单定金：" } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("formatToFixed2")(
                                _vm.orderInfoForm.paymentAmount
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c("el-form-item", { attrs: { label: "总折扣金额：" } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("formatToFixed2")(
                                _vm.orderInfoForm.totalDiscountAmount
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "hx-form-container box-shadow" }, [
      _c("p", { staticClass: "form-title" }, [_vm._v("收货信息")]),
      _c(
        "div",
        { staticClass: "form-details" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.receivingInfoForm } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "收货人手机号码：" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.receivingInfoForm.buyerMobile) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c("el-form-item", { attrs: { label: "收货地址：" } }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.receivingInfoForm.logisticsSiteName) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }